<!-- 字典列表 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false" @getPageInfo="searchData()" :showRefresh="true"></v-button>
        </div>
        <div class="page_content_center">
            <el-table size="mini" stripe :data="returnData.list" @selection-change="selecDataAction" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" row-key="id" :tree-props="{ children: 'children', hasChildren: false }" highlight-current-row>
                <el-table-column type="selection" width="40">
                </el-table-column>
                <el-table-column align="center" prop="id" label="ID" width="180">
                </el-table-column>
                <el-table-column align="center" prop="classCode" label="分类编码">
                </el-table-column>
                <el-table-column align="center" prop="className" label="分类名称">
                </el-table-column>
                <el-table-column align="center" prop="sort" label="排序">
                </el-table-column>
            </el-table>
        </div>
        <el-drawer :close-on-press-escape="true" :visible.sync="dialogVisible" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <classifyAction v-if="dialogVisible" ref="classifyAction" @drawerCancel="drawerCancel" :actionData="actionData"></classifyAction>
        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import classifyAction from "@/components/classifyAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {classifyAction},
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                className: '',
            },
            returnData: {
                list: []
            },
            classifyList: [],
            buttonList: [],
            selectedDataList: [],
            dialogVisible: false,



        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        selecDataAction(data) {
            this.selectedDataList = data
        },
        drawerCancel() {
            this.dialogVisible = false
            this.getDataList()
        },
        // 动作集合
        actionSet(actionData) {

            switch (actionData.actionType) {
                case 1:
                    this.dialogVisible = true;
                    this.actionData = {
                        cate: 0,
                        formData: "0",
                        oldData: "",
                        classifyList: this.classifyList,
                    };
                    break;
                case 2:
                    if (this.selectedDataList.length < 1) {
                        this.$message({
                            message: '请先选择您要修改的数据条目',
                            type: 'error'
                        });
                        return false
                    }

                    if (this.selectedDataList.length > 1) {
                        this.$message({
                            message: '编辑信息只能选择一条数据，请勿多选',
                            type: 'error'
                        });
                        return false
                    }

                    this.dialogVisible = true;
                    this.actionData = {
                        cate: 1,
                        formData: "0",
                        oldData: this.selectedDataList,
                        classifyList: this.classifyList,
                    };
                    break;
                case 3:
                    this.delDataAction()
                    break;
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
        // 数据搜索
        searchData() {
            this.getDataList()
        },
        // 删除
        delDataAction() {

            if (this.selectedDataList.length == 0) {
                this.$message({
                    message: '请勾选要删除的数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.selectedDataList[0]
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: this.selectedDataList.map(item => item.id)
                }
                let responseData = await this.$http.carouseClassifydelete(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            }).catch(() => { });

        },


        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.carouseClassifyqueryList(this.getRequestData)
            if (responseData.status == 200) {
                this.classifyList = []
                if (responseData.result.length > 0) {
                    this.returnData.list = this.handleJurisdiction(responseData.result)
                    this.classifyList = this.handleJurisdiction(responseData.result)
                    this.classifyList.unshift({
                        id: 0,
                        value: 0,
                        label: '顶级分类',
                        children: null
                    })
                } else {
                    this.returnData.list=[]
                    this.classifyList = [{
                        id: 0,
                        value: 0,
                        label: '顶级分类',
                        children: null
                    }]
                }
                console.log(this.classifyList);

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                if (value['parentId'] == id) {
                    value={...value}
                    value['id'] = value['id']
                    value['value'] = value['id']
                    value['label'] = value['className']
                    var list = this.handleJurisdiction(data, value['id'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = this.handleJurisdiction(data, value['id'], lev + 1);
                    }
                    son.push(value)

                }
            })
            return son;
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList()
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped></style>
